import { NewCard } from "@components/Cards/Templates/newCard";

type ContactRegistrationInfoCardProps = {
  contactData: any;
  isViewingHistory: boolean;
  createContact: boolean;
  implementerLogin: string;
};

export const ContactRegistrationInfoCard = ({
  contactData,
  isViewingHistory,
  createContact,
  implementerLogin,
}: ContactRegistrationInfoCardProps) => {
  const displayDate = createContact
    ? new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" })
    : contactData?.created_at?.split("T")[0];

  const today = new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });

  return (
    <NewCard
      header="登録情報"
      bodyLabel=""
      loading={false}
      bodyContents={
        <div>
          <h2 className="mb-5 label-light-blue-xl"> 登録日 </h2>
          <input
            type="text"
            className="form-text-field-border-gray"
            value={displayDate || today}
            required
            readOnly
          />

          {isViewingHistory && (
            <>
              <div className="divider mt-5 mb-6"></div>
              <h2 className="mb-5 label-light-blue-xl"> 登録者 </h2>
              <input
                type="text"
                className="form-text-field-border-gray"
                value={
                  implementerLogin !== "not found"
                    ? implementerLogin
                    : "削除されたユーザー"
                }
                required
                readOnly
              />
            </>
          )}
        </div>
      }
    />
  );
};
